import React from "react";
import { View, Text, Image } from "react-native";
import {
  BottomDrawer,
  Button,
  COMMON_STYLES,
  SIZE,
  SUBHEADING_STYLES,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";
import { CAMERA_FOCUSED, CLEARLY_VISIBLE, MOVE_CLOSER } from "../../assests/images";
import CameraIcon from "../../assests/icons/CameraIcon";

const tips = [
  {
    icon: MOVE_CLOSER,
    text: "Move closer to the crop and take a photo with the damaged area fully in frame.",
  },
  {
    icon: CAMERA_FOCUSED,
    text: "Ensure the camera is focused on the crop damage.",
  },
  {
    icon: CLEARLY_VISIBLE,
    text: "Ensure the crop is clearly visible with proper lighting.",
  },
];

const PoorImageQuality = ({
  onRetry,
  showModal,
}: {
  onRetry: () => void;
  showModal: boolean;
}) => {
  return (
    <BottomDrawer onClose={onRetry} visible={showModal}>
      <View
        style={[
          COMMON_STYLES.alignItemsCenter,
          COMMON_STYLES.flex1,
          { gap: 16 },
        ]}
      >
        <Text
          style={[
            TYPOGRAPHY.HEADING2,
            VARIANTS_STYLES.EMPHASIZED,
            TEXT_STYLES.textNeutral100,
          ]}
        >
          Poor Image Quality
        </Text>

        {tips.map((tip, index) => (
          <View
            key={index}
            style={[
              COMMON_STYLES.row,
              COMMON_STYLES.alignItemsCenter,
              COMMON_STYLES["mv1/2"],
              { gap: 12 },
            ]}
          >
            <Image
              source={tip.icon}
              style={{ width: 56, height: 56, borderRadius: 50 }}
              resizeMode="contain"
            />
            <Text style={[TYPOGRAPHY.TEXT2, TEXT_STYLES.textNeutral90]}>
              {tip.text}
            </Text>
          </View>
        ))}

        <Button
          buttonStyle={[COMMON_STYLES.fullWidth]}
          textStyle={[SUBHEADING_STYLES.MEDIUM_S2, TEXT_STYLES.textWhite]}
          text="Take a new photo"
          onClick={onRetry}
          iconLeft={<CameraIcon />}
          size={SIZE.large}
        />
      </View>
    </BottomDrawer>
  );
};

export default PoorImageQuality;
